import {useMemo} from 'react';
import {useQuery} from 'react-query';
import {CompanyCheckinsController} from '@pages/dashboard/company-legacy/company-components/company-checkins/company-checkins.controller';
import {CompanyCheckinsRequestImpl} from '@pages/dashboard/company-legacy/company-components/company-checkins/company-checkins.request';
import {CheckinDeadlineInput} from '../../shared/checkin-deadline.utils';

type ParticipantDeadlineRow = CheckinDeadlineInput & {id?: string};

export const useParticipantCheckinDeadlines = (
  userId?: string,
  workspaceId?: string,
  enabled = true,
) => {
  const controller = useMemo(
    () => new CompanyCheckinsController(new CompanyCheckinsRequestImpl()),
    [],
  );
  const {data: rows} = useQuery(
    ['participant-checkin-deadlines', workspaceId, userId],
    async (): Promise<ParticipantDeadlineRow[]> => {
      const response = await controller.getListOfCheckins(
        {user: userId, isSubmitted: false, paginate: false, include: 'cycle'},
        true,
      );
      return response && Array.isArray(response.data) ? response.data : [];
    },
    {
      enabled: enabled && Boolean(userId && workspaceId),
      refetchOnWindowFocus: false,
      retry: false,
    },
  );

  return useMemo(
    () =>
      new Map((rows || []).filter((row) => row.id).map((row) => [row.id, row])),
    [rows],
  );
};
